import { FundingPolicyType } from '@shared/appModel';
import { isCareMattersFamily } from '@shared/FundingPolicyTypeDef';
import { cmTwoPresentation } from './cmTwoPresentation';
import { nylAssetFlexPresentation } from './nylAssetFlexPresentation';
import { oaAssetCarePresentation } from './oaAssetCarePresentation';
import { traditionalLtcPresentation } from './traditionalLtcPresentation';
import { defaultPresentation, StrategyPresentation } from './types';

export function getPresentation(
  policyType: FundingPolicyType | null | undefined,
): StrategyPresentation {
  if (!policyType) return defaultPresentation;
  if (isCareMattersFamily(policyType)) return cmTwoPresentation;
  if (policyType === FundingPolicyType.nylAssetFlex) return nylAssetFlexPresentation;
  if (
    policyType === FundingPolicyType.assetCare ||
    policyType === FundingPolicyType.jointAssetCare
  ) {
    return oaAssetCarePresentation;
  }
  // Traditional / standalone LTC (generic) and CareScout Care Assurance share
  // the single-pool reimbursement presentation — see traditionalLtcStrategy.
  if (
    policyType === FundingPolicyType.longTermCareInsurance ||
    policyType === FundingPolicyType.careScoutCareAssurance
  ) {
    return traditionalLtcPresentation;
  }
  return defaultPresentation;
}
